export default "__VITE_ASSET__Bs_b2yqe__"